import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  OverlayTrigger,
  Tooltip,
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap';

import config from '../../config';

const coverageData = [
  { state: 'Alabama', email: 'sjog2010@proton.me' },
  { state: 'American Samoa', email: 'AccessInformation13@proton.me' },
  { state: 'Arizona', email: 'IdahoAccess@proton.me', note: '*' },
  { state: 'Arkansas', email: 'ARTogether@proton.me', note: '*' },
  { state: 'Florida', email: 'AccessFL@proton.me' },
  { state: 'Georgia', email: 'AccessGA@proton.me' },
  { state: 'Hawaii', email: 'HawaiiSupport@proton.me' },
];

const notes = [
  'Client response provided within 24 hours, seven days a week',
  'Medicines shipped by USPS priority mail or ground transport in discreet packaging with no tracking. (unless prefaced with an asterisk (*))',
  'Kits all contain one (1) 200 mg Mifepristone and 16 200 mcg Misoprostol for pregnancies 20 weeks and under (as recommended by MAHotline)',
  'Choice for clients of loose, unidentifiable pills or foil, blister packs depending on their security concerns and provider stock. Loose is sent default if no choice is made.',
  'Access to a personal, trained companion available for all clients and automatically assigned for clients over 14 weeks',
  'Service for all gestations',
  'No personal data retained or collected',
  'Clinicians available on request',
];

function renderNoteTooltip(marker, type) {
  return (
    <Tooltip>
      States prefaced with an ({marker}) follow different {type} protocols.
    </Tooltip>
  );
}

const ITEMS_PER_PAGE = 12;

export default function StateCoveragePaginated({
  title = 'Current Coverage by State',
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [activePage, setActivePage] = useState(1);
  const [regions, setRegions] = useState([]);
  const [filteredRegions, setFilteredRegions] = useState([]);

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const response = await fetch(
          `${config.contentBaseUrl}/content/items/region?fields={"name":1, "has_mailing_protocol":1, "has_dosing_protocol":1}&sort={"name":1}`,
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        setRegions(result);
        setFilteredRegions(result);
      } catch (error) {
        console.log(error.message);
      } finally {
        // console.log(regions);
      }
    };

    fetchRegions();
  }, []);

  useEffect(() => {
    const searchResults = regions.filter((region) =>
      region.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    setFilteredRegions(searchResults);
  }, [searchTerm, regions]);

  // const filteredData = coverageData.filter(({ state }) =>
  //   state.toLowerCase().includes(searchTerm.toLowerCase()),
  // );

  // const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  // const paginatedData = filteredData.slice(
  //   (activePage - 1) * ITEMS_PER_PAGE,
  //   activePage * ITEMS_PER_PAGE,
  // );

  // const handlePageChange = (pageNumber) => {
  //   setActivePage(pageNumber);
  // };

  const showResultText = searchTerm.trim().length > 0;

  const subject = 'Kit Request';
  const emailBody = `
    Name:
    Address:
    State:
    Date of Last Period:
    Date of Confirmation Test:
    Other Info:
  `;

  return (
    <div className="container my-4">
      <div className="section-title pb-0">
        <h5 className="mb-4">{title}</h5>
      </div>
      <div className="row">
        <div className="col-lg-8 col-md-8 col-12">
          <div className="text-muted fw-bold">
            {showResultText
              ? `${filteredRegions.length} result${filteredRegions.length !== 1 ? 's' : ''} found`
              : `Total Providers: ${filteredRegions.length}`}
          </div>
          <p className="text-muted">
            <i>
              States prefaced with an asterisk (
              <strong style={{ color: 'red' }}>*</strong>) follow different
              mailing methods.
            </i>{' '}
            <br />
            <i>
              States prefaced with (
              <strong style={{ color: 'orange' }}>^</strong>) have different
              dosing directions.
            </i>
          </p>
          <p className="text-muted"></p>
        </div>
        <div className="col-lg-4 col-md-4 col-12">
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search by state..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value.trim());
            }}
          />
        </div>
      </div>

      <div className="row">
        {filteredRegions.map(
          ({ _id, name, has_mailing_protocol, has_dosing_protocol }) => (
            <div className="col-md-4 mb-3" key={_id}>
              <div className="card shadow-sm py-3">
                <div className="card-body py-0">
                  <div>
                    <strong>
                      {has_mailing_protocol ? (
                        <OverlayTrigger
                          placement="top"
                          overlay={renderNoteTooltip('*', 'mailing')}
                        >
                          <span style={{ cursor: 'pointer', color: 'red' }}>
                            *
                          </span>
                        </OverlayTrigger>
                      ) : null}{' '}
                      {has_dosing_protocol ? (
                        <OverlayTrigger
                          placement="top"
                          overlay={renderNoteTooltip('^', 'dosing')}
                        >
                          <span style={{ cursor: 'pointer', color: 'orange' }}>
                            ^
                          </span>
                        </OverlayTrigger>
                      ) : null}{' '}
                      <Link
                        to={{
                          pathname: '/contact',
                          search: `?region_id=${_id}`,
                        }}
                      >
                        {name}
                      </Link>
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          ),
        )}
      </div>

      {regions.length === 0 && (
        <p className="text-muted">No matching state found.</p>
      )}

      {/* <p className="text-muted bg-light p-2 rounded">
        The above contact information is provided for community support groups
        that follow verified protocols (listed below) to ensure consistency and
        security for all clients regardless of location. States prefaced with an
        asterisk (*) follow different mailing protocols.
      </p> */}

      {/* <p className="mb-3 text-muted fw-bold">Service Note:</p>
      <ol className="list-group list-group-numbered border-0">
        {notes.map((note, index) => (
          <li key={index} className="list-group-item border-0 ps-0">
            {note}
          </li>
        ))}
      </ol> */}
      <h6>IF YOUR STATE IS NOT LISTED</h6>
      <p className="mt-4">
        Residents of other states may find abortion funding assistance through
        the National Network of{' '}
        <a href="https://abortionfunds.org/">Abortion Funds</a>.{' '}
        <a href="https://www.plancpills.org/" target="_blank">
          {' '}
          PlanCPills
        </a>{' '}
        lists all vendors, including for-profit, for all states and territories.
      </p>
    </div>
  );
}
